export const tncCodeList = {
  FREE_ADVISOR: 'FREE_ADV',
  BUY: 'BYR',
  PRIVACY_POLICY: 'PP',
  FREE_SELLER_BUYER: 'FREE_SNB',
  COMPANY: 'SLR_COMP',
  BUSINESS_IDEA: 'SLR_BUID',
  LOAN: 'SLR_LOAN',
  FRANCHISE: 'SLR_FRAN_SLSP',
  SALES_PARTNERSHIP: 'SLR_FRAN_SLSP',
  ADVISOR: 'PAID_ADV',
  GENERAL: 'GEN'
}
